import { formatEther, parseEther } from '@ethersproject/units';

export const calculateBuyoutPrice = (value: string | number) => {
  const tokenValue = parseEther(`${value}`);
  return Number(formatEther(tokenValue.mul(12).div(10)));
};
